import Component from '../core/Component'

export default class FormSearchOpener extends Component {

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
    }

    handleClick(event) {
        event.preventDefault()
        event.stopPropagation()

        const form = document.getElementById('form-search')

        if (!form) {
            return
        }

        const formSearch = Component.getFromElement(form)

        if (formSearch) {
            formSearch.toggle()
        }
    }
}